import L from "leaflet";
import { ICON_TYPES } from "./iconTypes";

// Icon configuration for each type
const createIconConfig = (iconUrl, size = [32, 32]) => ({
  iconUrl,
  iconSize: size,
  iconAnchor: [size[0] / 2, size[1] / 2],
  popupAnchor: [0, -size[1] / 2],
});

export const ICON_CONFIGS = {
  // [ICON_TYPES.EVENT1]: createIconConfig("/icons/event_type1.png"),
  // [ICON_TYPES.EVENT2]: createIconConfig("/icons/event_type2.png"),
  // [ICON_TYPES.EVENT3]: createIconConfig("/icons/event_type3.png"),
  // [ICON_TYPES.EVENT4]: createIconConfig("/icons/event_type4.png"),
  // [ICON_TYPES.EVENT5]: createIconConfig("/icons/event_type5.png"),
  // [ICON_TYPES.EVENT6]: createIconConfig("/icons/event_type6.png"),
  [ICON_TYPES.EVENT1]: createIconConfig("/eventicons/important_car.png",[42,33]),
  [ICON_TYPES.EVENT2]: createIconConfig("/eventicons/important_people.png",[27,42]),
  [ICON_TYPES.EVENT3]: createIconConfig("/eventicons/important_others.png",[33,33]),
  [ICON_TYPES.EVENT4]: createIconConfig("/eventicons/urgent_car.png",[42,33]),
  [ICON_TYPES.EVENT5]: createIconConfig("/eventicons/urgent_people.png",[27,42]),
  [ICON_TYPES.EVENT6]: createIconConfig("/eventicons/urgent_others.png",[33,33]),
};
